export class BankRecordTableResponse {
  id: number;
  consolidated: boolean;
  registrationDate: string;
  codCollaborator: string;
  collaboratorName: string;
  collaboratorSurname: string;
  fullName: string;
  totStatementLordo: number;
  consolidatingUser: string;
  lastUpdateUser: string;
  lastUpdateDate: string;
  signedDocument: boolean;
  codCoas?: string;
  desCoas?: string;

  constructor(
    id: number,
    consolidated: boolean,
    registrationDate: string,
    codCollaborator: string,
    collaboratorName: string,
    collaboratorSurname: string,
    totStatementLordo: number,
    consolidatingUser: string,
    lastUpdateUser: string,
    lastUpdateDate: string,
    signedDocument: boolean,
    codCoas?: string,
    desCoas?: string
  ) {
    this.id = id;
    this.consolidated = consolidated;
    this.registrationDate = registrationDate;
    this.codCollaborator = codCollaborator;
    this.collaboratorName = collaboratorName;
    this.collaboratorSurname = collaboratorSurname;
    this.fullName = `${collaboratorName ?? ''} ${collaboratorSurname ?? ''}`;
    this.totStatementLordo = totStatementLordo;
    this.consolidatingUser = consolidatingUser;
    this.lastUpdateUser = lastUpdateUser;
    this.lastUpdateDate = lastUpdateDate;
    this.signedDocument = signedDocument;
    this.codCoas = codCoas;
    this.desCoas = desCoas;
  }

  static fromJson(json: BankRecordTableResponse): BankRecordTableResponse {
    return new BankRecordTableResponse(
      json.id,
      json.consolidated,
      json.registrationDate,
      json.codCollaborator,
      json.collaboratorName,
      json.collaboratorSurname,
      json.totStatementLordo,
      json.consolidatingUser,
      json.lastUpdateUser,
      json.lastUpdateDate,
      json.signedDocument,
      json.codCoas,
      json.desCoas
    );
  }
}
